export default __webpack_public_path__ + "static/media/480_private01-it-mobile.7835516e.png";